import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Loading, SharingTables } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { cloneDeep } from 'lodash'
import * as actions from './actions'
import { Table } from '../root/components/common/table'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    noItemsWrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    link: {
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    tableInfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
}))

function ChooseDevices(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, locale } = useSelector(state => state.main)
    const { devices, selectedDevices } = useSelector(state => state.sharing)
    const [checkedInitialDevices, setCheckedInitialDevices] = useState({})
    const [checkedSelectedDevices, setCheckedSelectedDevices] = useState({})
    const [devicesMutable, setDevicesMutable] = useState(devices ? cloneDeep(devices) : [])
    const [selectedDevicesMutable, setSelectedDevicesMutable] = useState(cloneDeep(selectedDevices))

    const columns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        },
        {
            key: 'customer_name',
            label: locale.common.organisation,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        },
        {
            key: 'serial_number',
            label: locale.sharing.serialNr,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        }
    ]

    const setDevicesState = (data) => {
        dispatch(actions.devicesRequestSuccess(data))
        setCheckedInitialDevices({})
        setCheckedSelectedDevices({})
    }

    const setSelectedDevicesState = (data) => {
        dispatch(actions.setSelectedDevices(data))
        setCheckedInitialDevices({})
        setCheckedSelectedDevices({})
    }

    useEffect(() => {
        setDevicesMutable(cloneDeep(devices))
        setSelectedDevicesMutable(cloneDeep(selectedDevices))
    }, [devices, selectedDevices])

    return (
        <div className={classes.wrapper}>
            {isLoading &&
                <Loading/>
            }
            {!isLoading &&
                <React.Fragment>
                    {(!devicesMutable || devicesMutable.length === 0) && (!selectedDevicesMutable || selectedDevicesMutable.length === 0) &&
                        <div className={classes.noItemsWrapper}>
                            <div>
                                {locale.sharing.noDevicesToShare}
                            </div>
                        </div>
                    }
                    {((devicesMutable && devicesMutable.length > 0) || selectedDevicesMutable && selectedDevicesMutable.length > 0) &&
                        <SharingTables
                            leftData={devicesMutable}
                            rightData={selectedDevicesMutable}
                            selectedLeftData={checkedInitialDevices}
                            selectedRightData={checkedSelectedDevices}
                            uniqueKey='id'
                            setLeftData={setDevicesState}
                            setRightData={setSelectedDevicesState}
                            leftTable={
                                (devicesMutable && devicesMutable.length > 0)
                                ? (
                                    <Table
                                        rows={devicesMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedInitialDevices}
                                        select={setCheckedInitialDevices}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noDevicesLeft}
                                    </div>
                                )
                            }
                            rightTable={
                                (selectedDevicesMutable && selectedDevicesMutable.length > 0)
                                ? (
                                    <Table
                                        rows={selectedDevicesMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedSelectedDevices}
                                        select={setCheckedSelectedDevices}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noDevicesSelected}
                                    </div>
                                )
                            }
                        />
                    }
                </React.Fragment>
            }
        </div>
    )
}

export default withRouter(ChooseDevices)
